import { useMutation } from "@apollo/client";
import { CREATE_MEDIA_FOLDER } from "../../../graphql/mutation/mediaFolders";
import { MEDIA_FOLDERS } from "../../../graphql/query/mediaFolders";

export const normalizeAssetUrl = (url?: string) => {
  if (!url) return ''
  if (url.startsWith('//')) return `${window.location.protocol}${url}`
  return url
}

export const getPdfPreviewUrl = (url?: string) => {
  const normalizedUrl = normalizeAssetUrl(url)
  if (!normalizedUrl) return normalizedUrl
  if (normalizedUrl.includes('/attachments/download')) {
    if (normalizedUrl.includes('preview=')) return normalizedUrl
    return `${normalizedUrl}${normalizedUrl.includes('?') ? '&' : '?'}preview=1`
  }
  return normalizedUrl.includes('#') ? normalizedUrl : `${normalizedUrl}#view=FitH`
}

export const getPdfThumbnailUrl = (url?: string, width = 300) => {
  const pdfUrl = normalizeAssetUrl(url)
  if (!pdfUrl) return ''
  const previewSuffix = pdfUrl.includes('preview=')
    ? ''
    : `${pdfUrl.includes('?') ? '&' : '?'}preview=1`
  return `https://image.thum.io/get/auth/316-mailmunch/pdfSource/width/${width}/page/1/${pdfUrl}${previewSuffix}`
}

export const formatAssetFileSize = (bytes?: number) => {
  if (!bytes) return null
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export const formatAssetDate = (dateStr?: string) => {
  if (!dateStr) return null
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}

export const isPdfAsset = (item?: { asset_content_type?: string }) =>
  item?.asset_content_type === 'application/pdf'

// create Custom hook
export const useCreateFolder = () => {
  const [createMediaFolder, { loading, client }] = useMutation(CREATE_MEDIA_FOLDER);
  const createFolder = async (siteId: string | number, handleUpdateFolder: (folder: any, selectedFiles: any) => void , selectedFiles: Array<number>) => {
    try {
      const response = await createMediaFolder({
        variables: {
          name: 'New Folder',
          siteId: siteId
        }
      });
      client?.cache?.writeQuery({
        query: MEDIA_FOLDERS,
        variables: {
          siteId: siteId
        },
        data: {
          mediaFolders: [response.data.createMediaFolder]
        }
      });
      const { id } = response?.data?.createMediaFolder?.mediaFolder
      handleUpdateFolder && handleUpdateFolder({ value: id, label: 'New Folder' }, selectedFiles)
    } catch (error) {
      console.log(error, 'error----')
    }
  }
  return [createFolder, loading] as const;
}